<template>
  <div>
    <component
      :is="isDesktop ? 'p' : 'button'"
      class="flex w-full items-center justify-between px-3 py-3 text-left"
      :class="[
        !isDesktop && 'rounded-2xl hover:bg-gray-600_a35',
        !isDesktop && isOpen && 'bg-gray-600_a35',
      ]"
      @click="handleClick"
    >
      <span class="text-base font-bold leading-8 text-white tablet:text-xl">
        {{ title }}
      </span>
      <IconCaret
        v-if="!isDesktop"
        :direction="isOpen ? 'up' : 'down'"
        class="h-6 w-6 shrink-0 text-white tablet:h-7 tablet:w-7"
      />
    </component>

    <ul v-show="isDesktop || isOpen">
      <li v-for="item in links" :key="item.name">
        <TheNuxtLink
          :to="item.url"
          :title="item.name"
          class="block rounded-2xl px-3 py-2 text-xs leading-6 text-white hover:bg-gray-600_a35 tablet:rounded-3xl tablet:text-sm tablet:hover:bg-gray-600_a25 tablet:active:bg-gray-600_a35"
        >
          {{ item.name }}
        </TheNuxtLink>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
  import type { IFooterLink } from '@/composables/useFooterMenu';

  interface IProps {
    title: string;
    links: IFooterLink[];
  }

  defineProps<IProps>();

  const { isDesktop } = useScreen();

  const isOpen = ref<boolean>(false);

  const handleClick = (): void => {
    if (isDesktop.value) return;
    isOpen.value = !isOpen.value;
  };
</script>
